<template>
  <div class="faq-page-container mb-2">
    <h1>
      {{ title }}
    </h1>
    <h1>
      {{ subTitle }}
    </h1>
    <FaqGroup
      v-for="group in groups"
      :key="group.id"
      :group="group"
    />
  </div>
</template>

<script lang="ts">
export default {
  name: 'SFaq',
};
</script>

<script setup lang="ts">
import { computed, ref } from 'vue';
import StrapiService from '@slg/web-customer-shared/src/services/StrapiService';
import FaqGroup from './FaqGroup.vue';
import { useCmsLocaleReload } from '../../composables';

const faqPageData = ref<Record<string, any> | null>(null);
const faqPageDataGroups = ref<Array<{ title: unknown; items: unknown[] }> | null>(null);

const groups = computed(() => {
  if (faqPageData.value && faqPageDataGroups.value) {
    return faqPageDataGroups.value || [];
  }
  return [];
});
const title = computed(() => faqPageData.value?.pageTitle);
const subTitle = computed(() => faqPageData.value?.pageSubTitle);

function groupByArray(xs: any[], key: string, subKey: string) {
  return xs.reduce((rv, x) => {
    const v = x[key][subKey];
    const el = rv.find((r: { title: unknown }) => r && r.title === v);
    if (el) {
      el.items.push(x);
    } else {
      rv.push({ title: v, items: [x] });
    }
    return rv;
  }, []);
}

async function getFaqPageData() {
  try {
    faqPageData.value = await StrapiService.getFaqPage();
    const items = await StrapiService.getFaqItems();
    const itemsWithGroup = items.filter((item: Record<string, unknown>) => Object.prototype.hasOwnProperty.call(item, 'faq_group') && !!item.faq_group);
    faqPageDataGroups.value = groupByArray(itemsWithGroup, 'faq_group', 'title');
  } catch (error) {
    faqPageData.value = null;
  }
}

async function loadCmsData() {
  try {
    await getFaqPageData();
  } catch (e) {
  }
}

useCmsLocaleReload(loadCmsData);
</script>

<style lang="scss">
.faq-page-container {
  margin: 0 10%;
  padding: 30px;
  padding-top: 80px;
  min-height: 400px;
}
</style>
